import { Icon } from '@/components/Icon';
import { useT } from '@/lib/useLang';

/**
 * Juste sous le hero, comme les trois cartes de linkforce.in : ce que l'agence
 * prend en charge, en trois phrases vérifiables. Rien sur un compte-rendu, un
 * appel d'onboarding ou un chargé de compte : le service n'en fait pas.
 */
export function Services() {
  const t = useT();

  return (
    <section id="services" className="nz-services">
      <div className="nz-eyebrow">{t.servicesEyebrow}</div>
      <div className="nz-services__grid">
        {t.services.map((item, index) => (
          <div className={`nz-services__card${index === 1 ? ' nz-services__card--accent' : ''}`} key={item.title}>
            <div className="nz-services__mark">
              <Icon name={item.icon} className="nz-services__icon" />
            </div>
            <div className="nz-services__title">{item.title}</div>
            <p className="nz-services__body">{item.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
